// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body {
	--border-radius-base: 2px;
	--border-radius-small: 2px;
	--border-radius-large: 2px;
	--navbar-default-color: var(--white);
	--navbar-default-bg: var(--purple);
	--navbar-default-bg-dark: var(--purple-dark);
	--navbar-default-border: var(--navbar-default-bg-dark);
	--navbar-default-link-color: #777;
	--navbar-default-link-hover-color: #333;
	--navbar-default-link-hover-bg: transparent;
	--navbar-default-link-active-color: #555;
	--navbar-default-link-active-bg: var(--navbar-default-bg-dark);
	--navbar-default-link-disabled-color: #ccc;
	--navbar-default-link-disabled-bg: transparent;
	--link-color: var(--purple);
	--link-hover-color: var(--purple-light);
}

.navbar-default {
	color: var(--white);
	background: var(--navbar-default-bg) !important;
	border-color: var(--navbar-default-bg);
	box-shadow: none;
  /*0 1px 5px @box-shadow-1;*/;
}

.navbar-default .navbar-brand,
.navbar-default .navbar-brand:hover {
	text-shadow: none;
	color: var(--white);
}

.navbar-default,
.navbar-default .navbar-nav > li > a {
	text-shadow: none;
	color: var(--white);
}

.navbar-default,
.navbar-default .navbar-nav > li > a:hover {
	text-shadow: none;
	color: var(--white);
	background-color: var(--hover-on-dark-background);
}

.navbar-default .navbar-nav > .open > a,
.navbar-default .navbar-nav > .open > a:hover,
.navbar-default .navbar-nav > .open > a:focus,
.navbar-default .navbar-nav > li > a:hover,
.navbar-default .navbar-nav > li > a:focus {
	background: var(--hover-on-dark-background);
	color: var(--white);
}

nav.navbar .container {
	width: 100%;
}

@media (max-width: 767px) {
	.navbar-nav.navbar-right,
  .navbar-nav .open .dropdown-menu {
		position: absolute;
		left: auto;
		right: 15px;
		top: 0;
	}

	.navbar-nav .open .dropdown-menu {
		position: static;
		font-size: 14px;
		text-align: left;
		background-color: #fff;
		border: 1px solid #ccc;
		border-radius: 2px;
		-webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
		box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
		background-clip: padding-box;
	}
}

:root {
	--brand-primary: var(--green);
	--brand-primary-dark: var(--green-dark);
	--brand-info: var(--orange);
	--brand-warning: var(--pink);
	--btn-primary-color: #fff;
	--btn-primary-color-dark: #eee;
	--btn-primary-bg: var(--brand-primary);
	--btn-primary-bg-dark: var(--brand-primary-dark);
	--btn-primary-border: var(--btn-primary-bg-dark);
}

.nav-tabs > li > a {
	color: #7e7e7e;
	margin-right: 2px;
	margin-bottom: -5px;
	line-height: 1.42857143;
	border: none;
	border-bottom: 5px solid transparent;
	border-radius: 0;
  /*2px 2px 0 0;*/
  /*font-family: Montserrat, san-serif;*/
	font-size: 16px;
  /*font-weight:300; changing weights cause tabs to shift*/;
}

.nav-tabs > li.active > a,
.nav-tabs > li.active > a:hover,
.nav-tabs > li.active > a:focus {
	border: none !important;
	border-bottom: 5px solid var(--purple) !important;
	color: var(--purple) !important;
  /*font-weight:500;*/;
}

.nav-tabs {
	border-bottom: 5px solid var(--background) !important;
}

.modal-title {
	color: var(--purple);
}

.modal-header {
	background-color: #f7f7f7;
}

.btn-link:hover,
.btn-link:focus {
	text-decoration: none;
}
.caret {
	border-color: transparent;
}

.caret:hover {
	text-decoration: none;
}

.caret:after,
.rw-i-caret-down:before {
	content: "\\e904";
	font-family: 'feather' !important;
	speak: none;
	font-style: normal;
	font-weight: normal;
	font-variant: normal;
	text-transform: none;
	line-height: 1;
	position: absolute;
	top: 10px;
	right: 7px;
	vertical-align: middle;
	text-align: center;
}

a#profile-menu.dropdown-toggle > .caret:after {
	content: "\\e907";
	top: 50%;
	margin-top: -7px;
	right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/style/bootstrap-theme.css"],"names":[],"mappings":"AAEA;CACC,yBAAyB;CACzB,0BAA0B;CAC1B,0BAA0B;CAC1B,oCAAoC;CACpC,kCAAkC;CAClC,4CAA4C;CAC5C,sDAAsD;CACtD,iCAAiC;CACjC,uCAAuC;CACvC,2CAA2C;CAC3C,wCAAwC;CACxC,8DAA8D;CAC9D,0CAA0C;CAC1C,8CAA8C;CAC9C,2BAA2B;CAC3B,uCAAuC;AACxC;;AAEA;CACC,mBAAmB;CACnB,+CAA+C;CAC/C,sCAAsC;CACtC,gBAAgB;EACf,2BAA2B;AAC7B;;AAEA;;CAEC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;;CAEC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;;CAEC,iBAAiB;CACjB,mBAAmB;CACnB,iDAAiD;AAClD;;AAEA;;;;;CAKC,2CAA2C;CAC3C,mBAAmB;AACpB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC;;EAEC,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,MAAM;CACP;;CAEA;EACC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,mDAAmD;EACnD,2CAA2C;EAC3C,4BAA4B;CAC7B;AACD;;AAEA;CACC,6BAA6B;CAC7B,uCAAuC;CACvC,2BAA2B;CAC3B,4BAA4B;CAC5B,yBAAyB;CACzB,8BAA8B;CAC9B,sCAAsC;CACtC,gDAAgD;CAChD,gDAAgD;AACjD;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,oCAAoC;CACpC,gBAAgB;EACf,eAAe;EACf,sCAAsC;CACvC,eAAe;EACd,wDAAwD;AAC1D;;AAEA;;;CAGC,uBAAuB;CACvB,iDAAiD;CACjD,+BAA+B;EAC9B,mBAAmB;AACrB;;AAEA;CACC,qDAAqD;AACtD;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,qBAAqB;AACtB;AACA;CACC,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;AACtB;;AAEA;;CAEC,gBAAgB;CAChB,iCAAiC;CACjC,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,oBAAoB;CACpB,oBAAoB;CACpB,cAAc;CACd,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,QAAQ;CACR,gBAAgB;CAChB,WAAW;AACZ","sourcesContent":["@import \"theme.css\";\n\n.body {\n\t--border-radius-base: 2px;\n\t--border-radius-small: 2px;\n\t--border-radius-large: 2px;\n\t--navbar-default-color: var(--white);\n\t--navbar-default-bg: var(--purple);\n\t--navbar-default-bg-dark: var(--purple-dark);\n\t--navbar-default-border: var(--navbar-default-bg-dark);\n\t--navbar-default-link-color: #777;\n\t--navbar-default-link-hover-color: #333;\n\t--navbar-default-link-hover-bg: transparent;\n\t--navbar-default-link-active-color: #555;\n\t--navbar-default-link-active-bg: var(--navbar-default-bg-dark);\n\t--navbar-default-link-disabled-color: #ccc;\n\t--navbar-default-link-disabled-bg: transparent;\n\t--link-color: var(--purple);\n\t--link-hover-color: var(--purple-light);\n}\n\n.navbar-default {\n\tcolor: var(--white);\n\tbackground: var(--navbar-default-bg) !important;\n\tborder-color: var(--navbar-default-bg);\n\tbox-shadow: none;\n  /*0 1px 5px @box-shadow-1;*/;\n}\n\n.navbar-default .navbar-brand,\n.navbar-default .navbar-brand:hover {\n\ttext-shadow: none;\n\tcolor: var(--white);\n}\n\n.navbar-default,\n.navbar-default .navbar-nav > li > a {\n\ttext-shadow: none;\n\tcolor: var(--white);\n}\n\n.navbar-default,\n.navbar-default .navbar-nav > li > a:hover {\n\ttext-shadow: none;\n\tcolor: var(--white);\n\tbackground-color: var(--hover-on-dark-background);\n}\n\n.navbar-default .navbar-nav > .open > a,\n.navbar-default .navbar-nav > .open > a:hover,\n.navbar-default .navbar-nav > .open > a:focus,\n.navbar-default .navbar-nav > li > a:hover,\n.navbar-default .navbar-nav > li > a:focus {\n\tbackground: var(--hover-on-dark-background);\n\tcolor: var(--white);\n}\n\nnav.navbar .container {\n\twidth: 100%;\n}\n\n@media (max-width: 767px) {\n\t.navbar-nav.navbar-right,\n  .navbar-nav .open .dropdown-menu {\n\t\tposition: absolute;\n\t\tleft: auto;\n\t\tright: 15px;\n\t\ttop: 0;\n\t}\n\n\t.navbar-nav .open .dropdown-menu {\n\t\tposition: static;\n\t\tfont-size: 14px;\n\t\ttext-align: left;\n\t\tbackground-color: #fff;\n\t\tborder: 1px solid #ccc;\n\t\tborder-radius: 2px;\n\t\t-webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n\t\tbox-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n\t\tbackground-clip: padding-box;\n\t}\n}\n\n:root {\n\t--brand-primary: var(--green);\n\t--brand-primary-dark: var(--green-dark);\n\t--brand-info: var(--orange);\n\t--brand-warning: var(--pink);\n\t--btn-primary-color: #fff;\n\t--btn-primary-color-dark: #eee;\n\t--btn-primary-bg: var(--brand-primary);\n\t--btn-primary-bg-dark: var(--brand-primary-dark);\n\t--btn-primary-border: var(--btn-primary-bg-dark);\n}\n\n.nav-tabs > li > a {\n\tcolor: #7e7e7e;\n\tmargin-right: 2px;\n\tmargin-bottom: -5px;\n\tline-height: 1.42857143;\n\tborder: none;\n\tborder-bottom: 5px solid transparent;\n\tborder-radius: 0;\n  /*2px 2px 0 0;*/\n  /*font-family: Montserrat, san-serif;*/\n\tfont-size: 16px;\n  /*font-weight:300; changing weights cause tabs to shift*/;\n}\n\n.nav-tabs > li.active > a,\n.nav-tabs > li.active > a:hover,\n.nav-tabs > li.active > a:focus {\n\tborder: none !important;\n\tborder-bottom: 5px solid var(--purple) !important;\n\tcolor: var(--purple) !important;\n  /*font-weight:500;*/;\n}\n\n.nav-tabs {\n\tborder-bottom: 5px solid var(--background) !important;\n}\n\n.modal-title {\n\tcolor: var(--purple);\n}\n\n.modal-header {\n\tbackground-color: #f7f7f7;\n}\n\n.btn-link:hover,\n.btn-link:focus {\n\ttext-decoration: none;\n}\n.caret {\n\tborder-color: transparent;\n}\n\n.caret:hover {\n\ttext-decoration: none;\n}\n\n.caret:after,\n.rw-i-caret-down:before {\n\tcontent: \"\\e904\";\n\tfont-family: 'feather' !important;\n\tspeak: none;\n\tfont-style: normal;\n\tfont-weight: normal;\n\tfont-variant: normal;\n\ttext-transform: none;\n\tline-height: 1;\n\tposition: absolute;\n\ttop: 10px;\n\tright: 7px;\n\tvertical-align: middle;\n\ttext-align: center;\n}\n\na#profile-menu.dropdown-toggle > .caret:after {\n\tcontent: \"\\e907\";\n\ttop: 50%;\n\tmargin-top: -7px;\n\tright: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
